import { t } from '@lingui/macro';
import { useI18n } from 'utils/i18n';

const useAnnouncementName = () => {
  const { format } = useI18n();

  return (
    linkedContentTitle: string | undefined,
    announcementDate: Date | undefined,
    announcerName: string | undefined,
  ) => {
    const formattedDate = announcementDate
      ? format(announcementDate, 'PPP')
      : t`Unknown date`;
    return linkedContentTitle
      ? t`on ${linkedContentTitle}`
      : t`on ${formattedDate} by ${announcerName}`;
  };
};

export default useAnnouncementName;
